import { useState, useCallback, useMemo } from 'react';

export function useFEPagination<T>(data: T[], rowsPerPage = 40) {
  const [visibleCount, setVisibleCount] = useState(rowsPerPage);

  const displayedRows = useMemo(() => data.slice(0, visibleCount), [data, visibleCount]);

  const handleShowMore = useCallback(() => {
    setVisibleCount((prev) => prev + rowsPerPage);
  }, [rowsPerPage]);

  const hasMore = data.length > visibleCount;

  const totalCount = data.length;

  return { displayedRows, handleShowMore, hasMore, visibleCount, totalCount };
}
